
import { mapGetters, mapState } from 'vuex';
import BoardShowReviewInfoOption from '@/enums/BoardShowReviewInfoOption';

export default {
  name: 'AppReviewInfoSectionBoard',
  props: {
    review: {
      type: Object,
      required: true
    },
    showProductName: {
      type: Boolean,
      default: true
    },
    useLikesCount: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters('widget', ['device']),
    ...mapGetters('review', ['showScore', 'showDate']),
    ...mapState('widget', ['widget']),
    ...mapState('reviewSettings', ['reviewSettings']),
    BoardShowReviewInfoOption: () => BoardShowReviewInfoOption,
    shouldDisplayScoreOnCollapsed() {
      return (
        (this.widget.board_show_review_info_option &
          BoardShowReviewInfoOption.SHOW_SCORE) >
          0 && this.showScore(this.review)
      );
    },
    shouldDisplayDateOnCollapsed() {
      return (
        (this.widget.board_show_review_info_option &
          BoardShowReviewInfoOption.SHOW_CREATED_AT) >
          0 && this.showDate(this.review)
      );
    },
    shouldDisplayVerifiedBuyerBadge() {
      return !!this.review.verified_buyer_badge_image_url;
    }
  }
};
